import React, { useEffect, useState } from "react";
import axios from "axios";

const FreeToPaidConversion = () => {
  const [data, setData] = useState({ freeUsers: 0, paidUsers: 0 });

  useEffect(() => {
    const fetchConversion = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/admin/analytics/free-to-paid`
        );
        setData(res.data);
      } catch (error) {
      }
    };
    fetchConversion();
  }, []);

  return (
    <div className="widget">
      <h3>Free → Paid Conversion</h3>
      <p>Free Users: {data.freeUsers}</p>
      <p>Paid Users: {data.paidUsers}</p>
    </div>
  );
};

export default FreeToPaidConversion;
